import styled from 'styled-components';

const BalanceWarningStyled = styled.div`
  margin: 20px 0px;
  color: #e62771;
  border: 1px solid #e62771;
  padding: 10px;
  border-radius: 5px;
  font-weight: 500;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  p {
    flex: 1;
    text-align: center;
  }
`;

export default BalanceWarningStyled;
